import AccordionClass from "./html/accordion.js";

import SystemRules from "./Classes/rules.js";
import EmailList from "./Classes/Email/list.js";
import TabsClass from "./html/tabs.js";
import AddBid from "./addBid.js";
import MiniFilter from "./html/miniFilter.js";

export default class EmailPage{

    List
    Filter

    main
    _data

    get html(){
        return this.main
    }

    set data(d){
        console.log('c set', d)
        this._data = d
        this.Filter.eval(d.emails)
        this.render()
    }

    constructor(){
        this.Filter = new MiniFilter({
            defaultItem: {
                onChange: () => {
                    console.log('c se!!!t', this.Filter.values)

                    this.applyFilters(this.Filter.values)
                }
            }
        })

        this.List = $('<div>').attr('id', 'MessageList')
        this.main = $('<div>').append(this.Filter.html,this.List)
            .addClass('container-fluid')



        //==============================
        // this.ctx = $('#EmailsContainer');
        // this.data =  CS2.data
        //
        //
        // //
        // this.QuickFilterList = $('#QuickFilterList')
        // this.MessageList = $('#MessageList')
        // this.MessageView = $('#MessageView')
        // this.SideBar = $('#SideBar')
        //
        // let tabs = new TabsClass(this.MessageList)
        //
        // // msgObj.sideContainer =
        //
        // for (let category in this.data.pre??[]){
        //     let list = new EmailList(this.data.pre[category],{
        //         'Message': {
        //             // 'sideContainer': 'AddBid'
        //         },
        //         'Type': 'AddBid',
        //     })
        //     tabs.addTab(category, list.html)
        // }


        // $(['Invite','Addendum','Other']).each((k, f) => {
        //     let o = $('<div>').addClass('badge bg-secondary btn-group')
        //     let c = $('<span>').addClass('')
        //         .html(f)
        //
        //     let x = $('<input>')
        //         .attr({
        //             'type': 'radio',
        //             'value': f,
        //             'checked': true,
        //             'name': 'quickFilter',
        //         })
        //         .addClass('form-check-input filter-check')
        //         .on('click', () => {
        //             $('.accordion-item').each((index, item) => {
        //                 let i = $('.QFCol', item)[0]
        //                 const cellText = i.textContent || i.innerText;
        //                 // If cell content contains the search term, mark as found
        //                 if (cellText.indexOf(f) > -1) {
        //                     $(item).show()
        //                 }else{
        //                     $(item).hide()
        //                 }
        //             })
        //
        //
        //         })
        //     o.append(c,x)
        //     this.QuickFilterList.append(o)
        // })

    }

    applyFilters(data){
        let list = this.filterObjects(data)

        $('.emailLineItem').hide()

        for(let itm of list){
            $('#email-'+itm.id).show()

        }
    }

    filterObjects(filterCriteria) {
        return this._data.emails.filter(obj => {
            // Check if the object matches all filter criteria
            return Object.entries(filterCriteria).every(([property, allowedValues]) => {
                // Get the value of the property from the current object
                const objValue = obj[property];

                // If the property doesn't exist in the object, exclude it
                if (objValue === undefined) {
                    return false;
                }

                // If allowedValues is an array, check if objValue is in the array
                if (Array.isArray(allowedValues)) {
                    return allowedValues.includes(objValue);
                }

                // If allowedValues is a single value, check for equality
                return objValue === allowedValues;
            });
        });
    }

    render(){
            let list = new EmailList(this._data.emails,{
                'Message': {
                    // 'sideContainer': 'AddBid'
                },
                'Type': 'AddBid',
                'data': this._data
            })

        this.List.append(list.html)
    }



    renderAccount(messages){


        // $(data.folderList).each((key, item) => {
        // let item = 'INBOX'
        // let messages = data.folders[item]

        // let listing = this.addFolderListing(item)
        // $(messages).each((key, msg) => {
        //     // console.log('render', key,msg)
        //     msg.uid = msg.id
        //     if(!msg.uid) {
        //         CS.showError('Invalid data for email '+key)
        //         console.log(msg)
        //         return
        //     }
        //     let cleanupFunc = () => {
        //         ab = new AddBidClass()
        //         cont.html()
        //         $('.'+msgAccInd).remove()
        //         CS.ajaxCall({
        //             url: route('emails.import.msg'),
        //             data: {'id': msg.uid},
        //         }, (response) => {})
        //     }
        //     let cont = $('<div>').addClass('msg-'+key)
        //     let importBid = $('<div>').addClass('btn btn-success').html('Import')
        //         .on('click', ()=> {
        //             ab.save((r)=>{
        //                 if(r.failed){
        //                     return
        //                 }
        //                 //Cleanup
        //                 cleanupFunc()
        //             })
        //         })
        //
        //     let ignore = $('<div>').addClass('btn btn-warning').html('Ignore')
        //         .on('click', ()=>{
        //             cleanupFunc()
        //         })
        //     // listing.append(this.addListMessage(msg))
        //         //
        //
        //     let Export = $('<a>').addClass('btn btn-info').html('Export').attr('href',route('emails.get.raw', msg.uid))
        //
        //     // listing.append(this.addListMessage(msg))
        //
        //     let msgBox = $('<iframe>').addClass('border border-1 border-gray previewTabContainer w-100 h-100')
        //
        //     let ab = new AddBidClass()
        //
        //
        //
        //     let title = $('<div>').addClass('row w-100 m-0')
        //         .append(
        //             $('<div>').addClass('col-1 badge badge-warning bg-warning text-dark ms-auto text-truncate').html(msg.Type??'Other'),
        //             $('<div>').addClass('col text-truncate').html(msg.Subject),
        //             $('<div>').addClass('col-1  badge text-dark bg-info  text-truncate mx-2').html(msg.FromEmail),
        //             $('<div>').addClass('col-1  badge  bg-dark  text-truncate').html(msg.platform),
        //             $('<div>').addClass('col-1 badge bg-light text-dark ms-auto').html(msg.dateFormated)
        //         )
        //     // let end =
        //     // let titleCont = $('<div>').addClass('hstack gap-3 w-100')
        //     //     .append(title)
        //
        //     msg.ContractorID = msg.Contractor
        //     msg.projectName = msg.AI['Project Name']
        //     msg.address = msg.AI['Project Address']
        //     msg.dueDate = msg.AI['Due Date']
        //     msg.dueTime = msg.AI['Due Time']
        //     msg.Scope = msg.AI['Scope']
        //
        //
        //     let msgAccInd = this.Acc.add(title,cont, {'onOpen': () => {
        //         if(msgBox.attr('data-loaded') !== 'yes'){
        //
        //             msgBox.attr('data-loaded', 'yes')
        //             this.fetchMsg(msg.uid, msgBox)
        //
        //             ab.init(this.data, {
        //                 'context': $('#EmailsContainer'),
        //                 'container': cont,
        //                 'extraTabs': [{title: 'Email', content: msgBox}],
        //                 'buttons' : [ignore, importBid, Export],
        //                 'values': msg,
        //                 'postAttach': () => {
        //                     cleanupFunc()
        //                 }
        //             })
        //         }
        //         }})
        // })


    }


    // addFolderListing(data){
    //     let cont = $('<div>')
    //         .addClass('folder-listing')
    //
    //     this.MessageList.append(cont)
    //
    //     return cont
    // }
    //
    // addFolder(data){
    //     let cont = $('<div>')
    //         .html(data)
    //         .addClass('')
    //
    //     this.FoldersList.append(cont)
    //
    //     return cont
    // }

    addListMessage(data){
        let msg = $('<div>')
            .html(data.body)
            .addClass('message')

        let cont = $('<div>')
            .html(data.subject )
            .on('click', () => {
                // this.focusOn('message', msg)
                // this.MessageView.html(msg)

                // this.setSideBar(data)
            })
        this.Acc.add(cont,msg)
        return cont
    }

    focusOn(type, obj){

        if(type == 'folder'){
            $('.folder-listing').hide()

        }
        if(type == 'message'){
            $('.message').hide()
        }
        obj.show()
    }

    setSideBar(data){
        this.SideBar.html('')
        let attr = $('<div>')

        for(let key in data.attributes){
            let value = data.attributes[key]
            attr.append(this.renderAttrib(key,value))
        }

        if(data.attachments > 0){
            let button = $('<div>')
                .html('Get Attachments')
                .addClass('btn btn-success')
                .on('click', ()=>{

                })
            this.SideBar.append(button)

        }

        this.SideBar.append(attr)

    }

    renderAttrib(label, info){
        let l = $('<label>')
            .html(label)

        let v = $('<input>')
            .val(info)

        let out = $('<div>')
            .append(l,v)
        return out
    }

}
